import API_ENDPOINTS from '../constants/api_endpoints';
import { realBricksApi } from './api.service';

export const addPropertyPostApi = async (body) => {
  return realBricksApi.post(API_ENDPOINTS.PROPERTIES.AddProperty, body);
};

export const getPropertyType = async (body) => {
  const resp = await realBricksApi.get(
    `${API_ENDPOINTS.PROPERTY_TYPE.AddPropertyType}?page=1&&limit=100`
  );
  return resp.data;
};

export const preSignedUrl = async (body) => {
  const resp = await realBricksApi.post(API_ENDPOINTS.PRE_SIGNED_URL, body);
  return resp.data;
};

export const getAmenities = async () => {
  const resp = await realBricksApi.get(API_ENDPOINTS.AMENITIES.amenitiesList);
  return resp.data;
};

const searchTerm = (phrase) => {
  return phrase
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export const getPropertiesList = async (query, cancelToken) => {
  const {
    propertyTag,
    propertyType,
    propertyStatus,
    regulationType,
    sort,
    page,
    perPage,
    search,
  } = query;
 
  let propertyTypeString = '';
  if (propertyType.length > 0) {
    propertyType.forEach((type) => {
      propertyTypeString = `${propertyTypeString}&propertyType[]=${type}`;
    });
  }
  const resp = await realBricksApi.get(
    `${API_ENDPOINTS.PROPERTIES.GetPropertyList}?page=${page + 1
    }&&perPage=${perPage}${sort && `&&sort=${sort}`}${propertyStatus && `&&propertyStatus=${propertyStatus}`
    }${propertyTag && `&&propertyTag=${propertyTag}`}${propertyTypeString && `&${propertyTypeString}`
    }${search && `&&search=${searchTerm(search)}`}${regulationType && `&&regulationType=${regulationType}`}
    `,
    {
      cancelToken,
    }
  );
  return resp.data;
};

export const exportPropertiesService = async (query, signal) => {
  const {
    propertyTag,
    propertyType,
    propertyStatus,
    regulationType,
    sort,
    search,
  } = query;

  let propertyTypeString = '';
  if (propertyType.length > 0) {
    propertyType.forEach((type) => {
      propertyTypeString = `${propertyTypeString}&propertyType[]=${type}`;
    });
  }

  const response = await realBricksApi.get(`${API_ENDPOINTS.PROPERTIES.DownloadProperties}?${propertyTypeString}`, {
    params: {
      ...(sort && {sort}),
      ...(propertyStatus && { propertyStatus }),
      ...(propertyTag && { propertyTag }),
      ...(search && {search: searchTerm(search)}),
      ...(regulationType && { regulationType }),
    },
    signal
  });

  return response;
}

export const getProperty = async (id, cancelToken) => {
  const resp = await realBricksApi.get(
    `${API_ENDPOINTS.PROPERTIES.GetPropertyList}/${id}`,
    {
      cancelToken,
    }
  );
  return resp.data;
};

export const updateProperty = async (id, body) => {
  const resp = await realBricksApi.put(
    `${API_ENDPOINTS.PROPERTIES.AddProperty}/${id}`,
    body
  );
  return resp.data;
};

export const getCityList = async (query) => {
  const resp = await realBricksApi.get(
    `${API_ENDPOINTS.PROPERTIES.GetCityList}?limit=3000${query.stateCode ? `&&filterBy=${query.stateCode}` : ''
    }`
  );
  return resp.data;
};

export const getStateList = async () => {
  const resp = await realBricksApi.get(
    `${API_ENDPOINTS.PROPERTIES.GetStateList}?sortType=ASC&&limit=100`
  );
  return resp.data;
};

export const searchPropertyByName = (search) => {
  return realBricksApi.get(`${API_ENDPOINTS.PROPERTIES.GetPropertyList}`, {
    params: {
      ...(search && { search }),
    },
  });
};
export const deleteProperty = async (id) => {
  const resp = await realBricksApi.delete(
    `${API_ENDPOINTS.PROPERTIES.GetPropertyList}/${id}`
  );
  return resp.data;
};

export const getSellPropertiesService = async (
  page,
  limit,
  sortField,
  sortType,
  search
) => {
  let queryString = '';

  return realBricksApi.get(
    `${API_ENDPOINTS.PROPERTIES.GetSellYourProperties}?page=${page}&limit=${limit}&sortField=${sortField}&sortType=${sortType}${queryString}`,
    {
      params: {
        ...(search && { search }),
      },
    }
  );
};

export const deletePropertyImage = async (id, body) => {
  const resp = await realBricksApi.delete(
    `${API_ENDPOINTS.PROPERTIES.DeletePropertyImage}/${id}`,
    { data: body }
  );
  return resp.data;
};

export const propertySaveAsDraft = async (body) => {
  return realBricksApi.post(API_ENDPOINTS.PROPERTIES.PropertySaveAsDraft, body);
};
